/**
 * Beyond Instruction Types enums based on Docecbo instruction types
 */
export enum InstructionType {
  INSTRUCTOR_LED = 'Instructor-Led',
  INSTRUCTOR_LED_IN_PERSON = 'Instructor-Led (In-Person)',
  INSTRUCTOR_LED_VIRTUAL = 'Instructor-Led (Virtual)',
  SELF_STUDY = 'Self-study',
  QUICK_LEARNING = 'Quick Learning',
  E_LEARNING = 'eLearning',
  CERTIFICATION_EXAM = 'Certification Exam',
  COURSE = 'Course', // NOTE: Used by Course Detail only for UI only. Not used by Docebo
  WEBINAR = 'Webinar',
  WORKSHOP = 'Workshop',
}
